import { memo } from "react";
import LayerGroup from "./LayerGroup/LayerGroup";
import ElementGroup from "./ElementGroup/ElementGroup";

const ListTab = () => {
  return <>
    {/* Đối tượng */}
    <ElementGroup />
    {/* End Đối tượng */}
    {/* Lớp */}
    <LayerGroup />
    {/* End Lớp */}
  </>
};

export default memo(ListTab);